import { Injectable } from "@angular/core";
import { FacilityHandlerService } from "../handlers/facility-handler.service";
import { FacilityDTO, FacilityFloorDTO } from "./Facility";

@Injectable({
  providedIn: "root",
})
export class FacilityService {
  constructor(private FacilityHandlerService: FacilityHandlerService) {}

  //LIST
  getFacilities(
    masterAccountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
    },
  ) {
    return this.FacilityHandlerService.getFacilities(
      masterAccountID,
      queryParams,
    );
  }

  getFacility(masterAccountID: number, facilityID: number) {
    return this.FacilityHandlerService.getFacility(masterAccountID, facilityID);
  }

  deleteFacility(accountMasterID: number, facilityID: number) {
    return this.FacilityHandlerService.deleteFacility(
      accountMasterID,
      facilityID,
    );
  }

  createFacility(accountMasterID: number, facilityDTO: FacilityDTO) {
    const copy = { ...facilityDTO };
    copy.floors = undefined;
    return this.FacilityHandlerService.postFacility(accountMasterID, copy);
  }

  updateFacility(accountMasterID: number, facilityDTO: FacilityDTO) {
    const copy = { ...facilityDTO };
    copy.floors = undefined;
    return this.FacilityHandlerService.putFacility(accountMasterID, copy);
  }

  createFloor(accountMasterID: number, floorDTO: FacilityFloorDTO) {
    const copy = { ...floorDTO };
    copy.beacons = undefined;
    return this.FacilityHandlerService.postFloor(accountMasterID, copy);
  }

  updateFloor(accountMasterID: number, floorDTO: FacilityFloorDTO) {
    const copy = { ...floorDTO };
    copy.beacons = undefined;
    return this.FacilityHandlerService.putFloor(accountMasterID, copy);
  }

  deleteFloor(accountMasterID: number, floorDTO: FacilityFloorDTO) {
    return this.FacilityHandlerService.deleteFloor(accountMasterID, floorDTO);
  }
}
